import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription, forkJoin } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf, NgFor } from '@angular/common';

import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { AuctionOfferService } from '../../../services/auction-offer.service';
import { ProductFamilyTonnage } from '../../../models/offer-family';
import { MillTonnage } from '../../../models/mill';
import { UNIT_OPTIONS } from '../../../../shared/models/list';
import { NumberPipe } from '../../../../shared/pipes/number.pipe';
import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-auction-overview',
	templateUrl: './auction-overview.component.html',
	styleUrl: './auction-overview.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, TranslateModule, NgFor, MatRippleModule, MatIconModule, LoadingSpinnerComponent, NumberPipe]
})
export class AuctionOverviewComponent implements OnDestroy {
	isLoading = true;

	readonly UNIT_OPTIONS = UNIT_OPTIONS;

	auctionOverviewSub?: Subscription;

	openedAuctionOffersCount?: number;
	openedAuctionOffersAggregate?: number;
	familyTonnage: ProductFamilyTonnage[] = [];
	millTonnage: MillTonnage[] = [];

	constructor(
		private readonly auctionOfferService: AuctionOfferService,
		private readonly router: Router,
		private readonly route: ActivatedRoute
	) {
		this.auctionOverviewSub = forkJoin([
			this.auctionOfferService.getCountOfOpenedAuctionOffers(),
			this.auctionOfferService.getSumOfTonnageOfOpenedAuctionOffers(),
			this.auctionOfferService.getAvailableFamiliesAndTonnage(),
			this.auctionOfferService.getAvailableMillsAndTonnage()
		]).subscribe({
			next: ([countRes, aggRes, familyRes, millRes]) => {
				this.openedAuctionOffersCount = countRes.count;
				this.openedAuctionOffersAggregate = aggRes;
				const familiesSorted = familyRes.results;
				familiesSorted.sort(
					(a, b) => b.tonnage - a.tonnage
				);
				this.familyTonnage = familiesSorted;
				const millsSorted = millRes.results;
				millsSorted.sort(
					(a, b) => b.tonnage - a.tonnage
				);
				this.millTonnage = millsSorted;
			},
			error: (err: unknown) => {
				this.isLoading = false;
				console.error('error can\'t retrieve auctions info', err);
			},
			complete: () => {
				this.isLoading = false;
			}
		});
	}

	async viewDetails() {
		await this.router.navigate(['../bidding/offer-selection'], { relativeTo: this.route });
	}

	ngOnDestroy(): void {
		this.auctionOverviewSub?.unsubscribe();
	}
}
